import { getBackendUrl } from "@Utils";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import ModalStateDialogComponent from "../../cubeComponent/html/modal/ModalWithState";
import { importScheduleTasks } from "../../actions/task";
import { useParams } from "react-router-dom";
import { showToastNotification } from "../../actions/toast";
import {
  SOMETHING_WENT_WRONG,
  TOAST_TYPE_ERROR,
  TOAST_TYPE_SUCCESS,
  TOAST_TYPE_WARNING,
} from "../../services/constants";
import { useDispatch, useSelector } from "react-redux";
import GridComponent from "../../cubeComponent/html/grid";
import DropDownListComponent from "../../cubeComponent/form/DropdownListComponent";
import { convertP6XmlToJson } from "../Schedule/Gantt/P6XmlImport";
import axiosWrapper from "../../services/axiosWrapper";

import {
  ColumnsDirective,
  ColumnDirective,
  Inject,
  VirtualScroll,
  DetailRow,
  Resize,
} from "@syncfusion/ej2-react-grids";
import TreeGridComponent from "../../cubeComponent/html/treeGrid";
import {
  getPurchaseUnits,
  importCostDatabaseItemsFromExcelSheet,
  saveEstimateItemsFromExcelSheet,
} from "../../actions/estimation";
import {
  VirtualScroll as TreeVirtualScroll,
  Inject as TreeInject,
  DetailRow as TreeDetailRow,
  ColumnsDirective as TreeColumnsDirective,
  ColumnDirective as TreeColumnDirective,
} from "@syncfusion/ej2-react-treegrid";
import ToggleSwitchComponent from "../../cubeComponent/form/ToggleSwitchComponent";
import ToolTipComponent from "../../cubeComponent/html/tooltip";
import { DropDownButtonComponent } from "@syncfusion/ej2-react-splitbuttons";
import { convertMspXmlToJson } from "../Schedule/Gantt/MspXmlImport";
import {
  dateTypeDatasource,
  excelImportSources,
  excludeAutoMatchingColumns,
  getExampleFields,
  getGridColumns,
  getMatchDropdownDataSource,
  getRequiredFields,
  getSampleFile,
  saveContainers,
  scheduleDropDownDataSource,
  validateEstimateData,
  validateScheduleData,
  wbsPathTypeDatasource,
  xmlDropdownDatasource,
} from "./ExcelHelper";
import { formCategories } from "@Helpers";
import { importExcelContainers } from "../../actions/fileUpload";
import IconComponent from "@CubeComponents/icons";

function ExcelImport({ source, sourceId, showImportModal, setShowImportModal, refreshDataGrid, currentData }) {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [allJsonData, setAllJsonData] = useState(null);
  const [filteredJsonData, setFilteredJsonData] = useState(null);
  const [enableNextButton, setEnableNextButton] = useState(false);
  const estimateData = useSelector((state) => state.estimateData);
  const [purchaseUnitsList, setPurchaseUnitsList] = useState([]);
  const [customFields, setCustomFields] = useState({});
  const [excelImported, setExcelImported] = useState(false);
  const [allColumnNames, setAllColumnNames] = useState([]);
  const [wbsPathTypeIndex, setWbsPathTypeIndex] = useState(null);
  const [startDateTypeFormat, setStartDateTypeFormat] = useState(null);
  const [finishDateTypeFormat, setFinishDateTypeFormat] = useState(null);
  const [headerIndex, setHeaderIndex] = useState(null);
  const [finalData, setFinalData] = useState([]);
  const [showOnlyErrors, setShowOnlyErrors] = useState(true);
  const [currentTab, setCurrentTab] = useState("Upload File");
  const [columnMapper, setColumnMapper] = useState({});
  const [notValidPredecessors] = useState([]);
  const [estimateIcorrectData, setEstimateIcorrectData] = useState([]);
  const [scheduleIcorrectData, setScheduleIcorrectData] = useState([]);
  const [isEstimateDataValid, setIsEstimateDataValid] = useState(true);
  const [isScheduleDataValid, setIsScheduleDataValid] = useState(true);
  const [isXml, setIsXml] = useState(false);
  const [xmlSoftware, setXmlSoftware] = useState("P6");
  const [holidays, setHolidays] = useState(null);
  const [workWeek, setWorkWeek] = useState(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]);
  const [workTimings, setWorkTimings] = useState([{ from: 0, to: 24 }]);
  const [calendarArray, setCalendarArray] = useState(null);
  const [calendarDropdownDatasource, setCalendarDropdownDatasource] = useState([]);
  const [selectedCalendar, setSelectedCalendar] = useState(null);
  const [timingsDropdownDatasource, setTimingsDropdownDatasource] = useState([]);
  const [workTimingsArray, setWorkTimingsArray] = useState([]);
  const [workTimingsForDropDown, setWorkTimingsForDropdown] = useState([]);

  const params = useParams();
  const dispatch = useDispatch();
  const dropDownRef = useRef([]);
  const gridRef = useRef();
  const estimateValidateRef = useRef();
  const validateGridRef = useRef();
  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  const requiredFields = getRequiredFields({
    source,
    extraFields: customFields,
  });
  const exampleFields = getExampleFields({ source, extraFields: customFields });

  async function fetchPortalPurchaseUnits() {
    const response = await getPurchaseUnits();
    setPurchaseUnitsList(response.data.result);
  }
  async function fetchCurrentFormTemplate() {
    if (currentData) {
      const response = await axiosWrapper.post(`${getBackendUrl()}/projects/getFormTemplate`, {
        projectId: currentData.projectId,
        hierarchyId: currentData.hierarchyId,
        resourceType: formCategories.files,
      });
      setCustomFields(response.data.data);
    }
  }

  const gridColumns = ({ columnNames, allowCheckboxSelection, isValidateState, source, iconTemplate, idTemplate }) =>
    getGridColumns({
      columnNames,
      allowCheckboxSelection,
      isValidateState,
      source,
      iconTemplate,
      idTemplate,
    });

  function getColumnsDirective({
    columnNames,
    allowCheckboxSelection,
    isValidateState,
    source,
    componentType,
    iconTemplate,
    idTemplate,
  }) {
    return componentType === "treeGrid" ? (
      <TreeColumnsDirective>
        {gridColumns({
          columnNames,
          allowCheckboxSelection,
          isValidateState,
          source,
          iconTemplate,
          idTemplate,
        }).map((column) => (
          <TreeColumnDirective key={`columnDirective_${column.field}`} {...column} />
        ))}
      </TreeColumnsDirective>
    ) : (
      <ColumnsDirective>
        {gridColumns({
          columnNames,
          allowCheckboxSelection,
          isValidateState,
          source,
          iconTemplate,
          idTemplate,
        }).map((column) => (
          <ColumnDirective
            key={`columnDirective_${column.field}`}
            {...column}
            headerTemplate={() => columnHeaderTeplate(column)}
          />
        ))}
      </ColumnsDirective>
    );
  }

  const columnHeaderTeplate = (args) => (
    <div className="flex">
      {args.isMandatory && <span className="text-2xl leading-4 font-light text-red-500">*</span>}
      <p>{args.headerText}</p>
    </div>
  );

  const getGridComponent = useCallback(
    (props) => (
      <GridComponent
        ref={gridRef}
        dataSource={props.dataSource}
        height={props.height ?? "100%"}
        width={props.width ?? "100%"}
        enableStickyHeader
        enableVirtualization
        rowSelected={props.rowSelected}
        rowDeselected={props.rowSelected}
        allowResizing
        selectionSettings={{ mode: "Row", type: "Single" }}
      >
        {getColumnsDirective({
          columnNames: props.columnNames,
          allowCheckboxSelection: true,
          isValidateState: props.isValidateState,
          iconTemplate,
          source: props.source,
          idTemplate,
        })}
        <Inject services={[VirtualScroll, DetailRow, Resize]} />
      </GridComponent>
    ),
    [],
  );
  const scheduleFinalTreeGrid = useCallback(
    (props) => (
      <TreeGridComponent
        dataSource={props.dataSource}
        idMapping="mysqlId"
        parentIdMapping="parentId"
        height="100%"
        enableVirtualization
      >
        {getColumnsDirective({ source, componentType: "treeGrid", idTemplate })}
        <TreeInject services={[TreeVirtualScroll]} />
      </TreeGridComponent>
    ),
    [],
  );
  const scheduleValidateGrid = useCallback(
    (props) => (
      <GridComponent
        ref={validateGridRef}
        dataSource={props.dataSource}
        allowResizing
        height={270}
        enableVirtualization
      >
        {getColumnsDirective({
          source,
          isValidateState: true,
          iconTemplate,
          idTemplate,
        })}
        <Inject services={[VirtualScroll, Resize, DetailRow]} />
      </GridComponent>
    ),
    [],
  );
  const estimateFinalTreeGrid = useCallback(
    (props) => (
      <TreeGridComponent
        dataSource={props.dataSource}
        idMapping="rowNo"
        parentIdMapping="parent"
        height={300}
        enableVirtualization
      >
        {getColumnsDirective({ source, componentType: "treeGrid" })}
        <TreeInject services={[TreeVirtualScroll, TreeDetailRow]} />
      </TreeGridComponent>
    ),
    [],
  );
  const estimateValidateGrid = useCallback(
    (props) => (
      <GridComponent
        ref={estimateValidateRef}
        dataSource={props.dataSource}
        allowResizing
        height={270}
        enableVirtualization
      >
        {getColumnsDirective({ source, isValidateState: true, iconTemplate })}
        <Inject services={[VirtualScroll, Resize, DetailRow]} />
      </GridComponent>
    ),
    [],
  );

  const handleDropdownChange = (e, columnName) => {
    let tempObj = {};
    let columnNameNotFound = true;
    Object.keys(columnMapper).map((key) => {
      if (e.value == columnMapper[key]) {
        tempObj = {
          ...columnMapper,
          [columnName]: e.value,
        };
        delete tempObj[key];
        columnNameNotFound = false;
      }
    });
    if (columnNameNotFound) {
      tempObj = {
        ...columnMapper,
        [columnName]: e.value,
      };
    }
    setColumnMapper({ ...tempObj });
  };

  const autoMatching = () => {
    let temp = {};
    if (source == excelImportSources.SCHEDULE) {
      allColumnNames.map((column) => {
        if (requiredFields.includes(column)) {
          if (!excludeAutoMatchingColumns.includes(column)) {
            temp = {
              ...temp,
              [column]: column,
            };
          }
        }
      });
      setColumnMapper(temp);
    } else if (source == excelImportSources.FILES) {
      allColumnNames.map((column) => {
        if (requiredFields.find((field) => field.headerText == column)) {
          temp = {
            ...temp,
            [column]: column,
          };
        }
      });
      setColumnMapper(temp);
    } else {
      allColumnNames.map((column) => {
        if (requiredFields.includes(column)) {
          temp = {
            ...temp,
            [column]: column == "HSN/SAC" ? "HSN_SAC" : column == "Purchase Unit Name" ? "unit" : column.toLowerCase(),
          };
        }
      });
      setColumnMapper(temp);
    }
  };

  const validatorFunction = () => {
    if (source === excelImportSources.SCHEDULE) {
      validateScheduleData({
        sourceId: params.scheduleId,
        filteredJsonData,
        notValidPredecessors,
        setEnableNextButton,
        setScheduleIcorrectData,
        setIsScheduleDataValid,
        setFinalData,
        columnMapper,
        startDateTypeFormat,
        finishDateTypeFormat,
        wbsPathTypeIndex,
      });
    } else if (source === excelImportSources.ESTIMATE || source === excelImportSources.COST_DATABASE) {
      validateEstimateData({
        source,
        sourceId,
        estimateData,
        headerIndex,
        filteredJsonData,
        purchaseUnitsList,
        setEstimateIcorrectData,
        setIsEstimateDataValid,
        setEnableNextButton,
        setFinalData,
        columnMapper,
        dispatch,
      });
    } else if (source === excelImportSources.FILES) {
      saveContainers({
        filteredJsonData,
        setFinalData,
        columnMapper,
        extraFields: customFields,
      });
    }
  };

  const handleSelectHeader = (e) => {
    if (e.isInteracted) {
      const dataGrid = e.target.closest(".e-grid").ej2_instances[0];
      const selectedRecord = dataGrid.getSelectedRecords();
      const selectedRecordIndex = dataGrid.getSelectedRowIndexes();
      if (selectedRecord.length == 1) {
        const selectedRow = selectedRecord[0].filter((record) => record);
        setAllColumnNames(selectedRow);
        setHeaderIndex(selectedRecordIndex[0]);
        const temp = allJsonData.filter((data, index) => {
          if (index > selectedRecordIndex[0]) return data;
        });
        const convertArrayDataToObject = (data, colName) => {
          const resultObject = {};
          colName.forEach((value, index) => {
            resultObject[value] = data[index];
          });
          return resultObject;
        };
        const mappedData = temp.map((data) => convertArrayDataToObject(data, selectedRow));
        setFilteredJsonData(mappedData);
        setEnableNextButton(true);
      } else {
        setEnableNextButton(false);
        setFilteredJsonData(null);
        setAllColumnNames([]);
        setHeaderIndex(null);
      }
    }
  };

  const handleFileUpload = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
      if (e.target.files[0].name.split(".").pop() == "xml") {
        setIsXml(true);
      } else {
        setIsXml(false);
      }
      setEnableNextButton(true);
    } else {
      setEnableNextButton(false);
    }
  };

  const iconTemplate = (args) =>
    args.type && (
      <IconComponent name="details" position="right" className="cursor-pointer" toolTipContent={args.type} />
    );
  const idTemplate = (args) => {
    if (args.WBSCode) {
      return args.WBSCode;
    }
    return args.customTaskId;
  };
  function WBSPathTemplate(data) {
    return (
      <ToolTipComponent position="right" content={data.type}>
        {data.name}
      </ToolTipComponent>
    );
  }

  const showValidateData = () => {
    if (source == excelImportSources.FILES) {
      return getGridComponent({
        dataSource: finalData,
        columnNames: allColumnNames,
        isValidateState: !!excelImported,
      });
    }
    if (source == excelImportSources.SCHEDULE) {
      if (isScheduleDataValid || isXml) {
        return scheduleFinalTreeGrid({ dataSource: finalData });
      }
      const temp = [];
      finalData.map((data) => {
        let isFound = false;
        scheduleIcorrectData.map((error) => {
          if (error.id == data.customTaskId) {
            isFound = true;
            temp.push(error);
          }
        });
        if (!isFound) {
          data.startDate = data.startDate
            ? typeof data.startDate == "string"
              ? data.startDate
              : new Date(data.startDate)
            : null;
          data.endDate = data.endDate
            ? typeof data.endDate == "string"
              ? data.endDate
              : new Date(data.endDate)
            : null;
          temp.push(data);
        }
      });
      return (
        <div>
          <div className="flex justify-between">
            <div className="mb-2 font-bold text-sm">{t("Following Rows have Errors.")}</div>
            <ToggleSwitchComponent
              label="Only Show Rows with error "
              checked={showOnlyErrors}
              onChange={() => {
                setShowOnlyErrors(!showOnlyErrors);
                showOnlyErrors
                  ? (validateGridRef.current.dataSource = temp)
                  : (validateGridRef.current.dataSource = scheduleIcorrectData);
              }}
            />
          </div>
          {scheduleValidateGrid({ dataSource: scheduleIcorrectData })}
        </div>
      );
    }
    if (isEstimateDataValid) {
      // had to do because in treeComponent "level" is reserved key and parentmapping should start with 1 either it didn't show all rows.
      const newData = finalData.map((item) => {
        const newItem = { ...item };
        delete newItem.level;

        newItem.rowNo = newItem.rowNo - 1;
        if (newItem.parent != "") {
          newItem.parent = newItem.parent - 1;
        } else {
          newItem.parent = null;
        }
        return newItem;
      });
      return estimateFinalTreeGrid({ dataSource: newData });
    }
    const temp = [];
    finalData.map((data) => {
      let isFound = false;
      estimateIcorrectData.map((error) => {
        if (error.row == data.rowNo) {
          isFound = true;
        }
      });
      if (!isFound) {
        temp.push(data);
      }
    });
    temp.push(...estimateIcorrectData);
    return (
      <div>
        <div className="flex justify-between">
          <div className="mb-2 font-bold text-sm">{t("Following Rows have Errors.")}</div>
          <ToggleSwitchComponent
            label="Only Show Rows with error "
            checked={showOnlyErrors}
            onChange={() => {
              setShowOnlyErrors(!showOnlyErrors);
              showOnlyErrors
                ? (estimateValidateRef.current.dataSource = temp)
                : (estimateValidateRef.current.dataSource = estimateIcorrectData);
            }}
          />
        </div>
        {estimateValidateGrid({ dataSource: estimateIcorrectData })}
      </div>
    );
  };

  useEffect(() => {
    if (currentTab == "Match Columns") {
      allColumnNames.map((col, index) => {
        const temp = Object.keys(columnMapper);
        if (!temp.includes(col)) {
          dropDownRef.current[index].value = null;
        }
      });
    }
    if (gridRef.current) {
      currentTab == "Select Header"
        ? (gridRef.current.columns[0].visible = true)
        : (gridRef.current.columns[0].visible = false);
      gridRef.current.refresh();
    }

    if (currentTab == "Validate Data" && isXml) {
      setEnableNextButton(true);
    }
  }, [columnMapper, currentTab]);

  useEffect(() => {
    fetchPortalPurchaseUnits();
    fetchCurrentFormTemplate();
  }, []);

  useEffect(() => {
    if (
      source == excelImportSources.SCHEDULE &&
      wbsPathTypeIndex != null &&
      startDateTypeFormat != null &&
      finishDateTypeFormat != null &&
      Object.keys(columnMapper).length == scheduleDropDownDataSource.length
    ) {
      setEnableNextButton(true);
    } else if (
      (source == excelImportSources.ESTIMATE ||
        source === excelImportSources.COST_DATABASE ||
        source === excelImportSources.FILES) &&
      Object.keys(columnMapper).length == requiredFields.length
    ) {
      setEnableNextButton(true);
    }
  }, [columnMapper, wbsPathTypeIndex, startDateTypeFormat, finishDateTypeFormat]);

  const getHeader = (headerName, index) => (
    <div className={currentTab == headerName ? "flex text-sm gap-1" : "flex opacity-20 text-sm gap-1"}>
      <span className="font-semibold h-5 w-5 flex justify-center items-center rounded-full bg-button_light">
        {index}
      </span>
      {headerName}
    </div>
  );

  const handleXmlSoftwareSelection = (args) => {
    setXmlSoftware(args.item.properties.text);
  };

  const handleCalendarSelection = (args) => {
    const tempWorkTimingsArray = [];
    const workTimingsTempdataSource = [];
    const tempdataSourceArray = [];
    const tempWorkingDays = [];
    const tempHolidays = [];
    let counter = 0;

    if (xmlSoftware == "P6") {
      calendarArray[args.item.properties.id].HolidayOrExceptions.HolidayOrException.map((day) => {
        if (day.WorkTime["@_xsi:nil"]) {
          tempHolidays.push({ FromDate: day.Date, ToDate: day.Date });
        }
      });
      setHolidays(tempHolidays);

      calendarArray[args.item.properties.id].StandardWorkWeek.StandardWorkHours.forEach((day) => {
        if (!day.WorkTime["@_xsi:nil"]) {
          tempWorkingDays.push(day.DayOfWeek);
          const worktimings = [];
          let tempdatasource = "";
          if (!day.WorkTime.length) {
            const fromHour = parseInt(day.WorkTime.Start.split(":")[0], 10);
            let toHour = parseInt(day.WorkTime.Finish.split(":")[0], 10);
            const finishMinutes = parseInt(day.WorkTime.Finish.split(":")[1], 10);
            if (finishMinutes !== 0) {
              toHour += 1;
            }
            worktimings.push({ from: fromHour, to: toHour });
            tempdatasource += `${fromHour}-${toHour}`;
          } else {
            day.WorkTime.forEach((range, index) => {
              const fromHour = parseInt(range.Start.split(":")[0], 10);
              let toHour = parseInt(range.Finish.split(":")[0], 10);
              const finishMinutes = parseInt(range.Finish.split(":")[1], 10);
              if (finishMinutes !== 0) {
                toHour += 1;
              }
              worktimings.push({ from: fromHour, to: toHour });
              tempdatasource += `${fromHour}-${toHour}`;
              if (index < day.WorkTime.length - 1) {
                tempdatasource += " , ";
              }
            });
          }

          if (!tempdataSourceArray.includes(tempdatasource)) {
            tempdataSourceArray.push(tempdatasource);
            tempWorkTimingsArray.push(worktimings);
            workTimingsTempdataSource.push({
              text: tempdatasource,
              id: counter,
            });
            counter += 1;
          }
        }
      });
    } else if (xmlSoftware == "MSP") {
      const tempWorkTiming = [];

      calendarArray[args.item.properties.id].WeekDays.WeekDay.map((day) => {
        if (day.DayType == 0 && day.DayWorking == 0) {
          tempHolidays.push(day.TimePeriod);
        } else if (day.DayType > 0 && day.DayWorking == 1) {
          tempWorkTiming.push(day.WorkingTimes.WorkingTime);
          tempWorkingDays.push(dayNames[day.DayType % 7]);
        }
      });

      tempWorkTiming.map((day) => {
        const worktimings = [];
        let tempdatasource = "";
        if (!day.length) {
          const fromHour = parseInt(day.FromTime.split(":")[0], 10);
          let toHour = parseInt(day.ToTime.split(":")[0], 10);
          const finishMinutes = parseInt(day.ToTime.split(":")[1], 10);
          if (finishMinutes !== 0) {
            toHour += 1;
          }
          worktimings.push({ from: fromHour, to: toHour });
          tempdatasource += `${fromHour}-${toHour}`;
        } else {
          day.forEach((range, index) => {
            const fromHour = parseInt(range.FromTime.split(":")[0], 10);
            let toHour = parseInt(range.ToTime.split(":")[0], 10);
            const finishMinutes = parseInt(range.ToTime.split(":")[1], 10);
            if (finishMinutes !== 0) {
              toHour += 1;
            }
            worktimings.push({ from: fromHour, to: toHour });
            tempdatasource += `${fromHour}-${toHour}`;
            if (index < day.length - 1) {
              tempdatasource += " , ";
            }
          });
        }
        if (!tempdataSourceArray.includes(tempdatasource)) {
          tempdataSourceArray.push(tempdatasource);
          tempWorkTimingsArray.push(worktimings);
          workTimingsTempdataSource.push({ text: tempdatasource, id: counter });
          counter += 1;
        }
      });
      setHolidays(tempHolidays);
    }
    setTimingsDropdownDatasource(workTimingsTempdataSource);
    setWorkWeek(tempWorkingDays);
    setSelectedCalendar(args.item.properties.text);
    setWorkTimingsArray(tempWorkTimingsArray);
    setWorkTimingsForDropdown("");
  };

  const handleTimingsSelection = (args) => {
    setWorkTimings(workTimingsArray[args.item.properties.id]);
    setWorkTimingsForDropdown(timingsDropdownDatasource[args.item.properties.id].text);
    setEnableNextButton(true);
  };
  const getSizeForColumn = () => (source === excelImportSources.COST_DATABASE ? 225 : 160);
  const getHeaderLine = () => <div className="border-black border-b-2 w-10 opacity-20" />;

  const importModalContent = () => {
    if (currentTab == "Upload File") {
      const fieldsToShow = requiredFields;
      const dataForFields = exampleFields;
      return (
        <div className="h-full p-6">
          <div className="">
            <div className="font-bold text-xl"> Upload File </div>
            <div className="mt-4 font-bold text-lg"> Data that we expect: </div>
            <div className="text-sm"> (You will have a chance to rename or remove columns in next steps)</div>
          </div>
          <div className="mt-6">
            {getGridComponent({
              dataSource: dataForFields,
              columnNames: fieldsToShow,
              source: source == excelImportSources.FILES ? source : null,
              height: 80,
            })}
          </div>

          <div className=" mt-6 font-semibold text-sm">
            Please
            <a
              className="hover:underline mx-1 cursor-pointer"
              style={{ color: "#6BBBE3" }}
              onClick={() => getSampleFile({ source, extraFields: customFields })}
            >
              download
            </a>
            the template first and use the exact format when you upload in case of .XLS/.XLSX/.CSV files
          </div>

          <div className="mt-8 me-6 border-2 border-solid border-gray-200 w-full p-2">
            <label htmlFor="fileUploadExcelImport">
              <input
                type="file"
                accept=".xls,.xlsx,.csv,.xml"
                id="fileUploadExcelImport"
                className="hidden"
                onChange={handleFileUpload}
              />
              <div className="flex relative cursor-pointer">
                <div
                  className={`px-2 py-1 shadow-md rounded ${file ? "opacity-40" : ""}`}
                  style={{ backgroundColor: "#ecf3fe" }}
                >
                  Upload File (.xlsx, .xls, .csv or .xml supported)
                </div>
                <span className="justify-center items-center ms-2 mt-1 text-sm">
                  {" "}
                  {file ? file.name : "No File Chosen"}{" "}
                </span>
              </div>
            </label>
          </div>
          <div className="ms-4 text-sm">
            **only imports data from the first sheet if your Excel file contains multiple sheets.
          </div>
          {isXml && (
            <div className=" flex items-center gap-6 mt-8 font-semibold text-sm">
              Choose the software from which XML is exported
              <DropDownButtonComponent
                cssClass="bg-primary_blue h-8 px-4 rounded-sg"
                items={xmlDropdownDatasource}
                select={handleXmlSoftwareSelection}
                content={xmlSoftware}
                popupWidth="50px"
              />
            </div>
          )}
        </div>
      );
    }
    if (currentTab == "Select Header") {
      return (
        <div className="p-6">
          <div className="font-bold text-xl h-6">{t("Select Header Row")}</div>
          <div className="mt-4 h-full">
            {getGridComponent({
              dataSource: allJsonData,
              columnNames: Object.keys(allJsonData[0]),
              rowSelected: handleSelectHeader,
              height: 330,
            })}
          </div>
        </div>
      );
    }
    if (currentTab == "Match Columns") {
      return (
        <div className="p-6 h-full w-full">
          <div className="font-bold text-xl">{t("Match Columns")}</div>
          <div className="mt-4 font-bold text-md"> Your Table</div>
          <div className="mt-4 h-1/3">
            {getGridComponent({
              dataSource: filteredJsonData,
              columnNames: allColumnNames,
              height: 100,
              // width: `${allColumnNames.length * getSizeForColumn()}px`,
            })}
          </div>
          <div className="mt-10 font-bold text-md ">{t("Will Become")}</div>
          <div className="flex mt-4  p-2 w-full">
            <div className="flex gap-3 w-full">
              {allColumnNames.map((columnName, index) => (
                <div key={index} className="flex-1 flex-col">
                  <DropDownListComponent
                    key={index}
                    id={index}
                    ref={(ref) => (dropDownRef.current[index] = ref)}
                    // width={`${getSizeForColumn() - 13}px`}
                    buttonType={BUTTON_TYPES.DROPDOWN_GRADIENT_LIST}
                    dataSource={getMatchDropdownDataSource({
                      source,
                      customFields,
                    })}
                    popupWidth={`${getSizeForColumn()}px`}
                    fields={{ text: "name", value: "value" }}
                    value={columnMapper[columnName]}
                    onChange={(e) => {
                      handleDropdownChange(e, columnName, index);
                    }}
                  />
                  {dropDownRef.current[index]?.value == "WBSPath" && (
                    <div className="mt-6 gap-4">
                      <DropDownListComponent
                        itemTemplate={WBSPathTemplate}
                        buttonType={BUTTON_TYPES.DROPDOWN_GRADIENT_LIST}
                        dataSource={wbsPathTypeDatasource}
                        fields={{ text: "name", value: "index" }}
                        onChange={(e) => {
                          setWbsPathTypeIndex(e.value);
                        }}
                        popupWidth={`${getSizeForColumn()}px`}
                      />
                    </div>
                  )}
                  {dropDownRef.current[index]?.value == "Start" && (
                    <div className="mt-6 gap-4">
                      <DropDownListComponent
                        buttonType={BUTTON_TYPES.DROPDOWN_GRADIENT_LIST}
                        dataSource={dateTypeDatasource}
                        fields={{ text: "name", value: "value" }}
                        onChange={(e) => {
                          setStartDateTypeFormat(e.value);
                        }}
                        popupWidth={`${getSizeForColumn()}px`}
                      />
                    </div>
                  )}
                  {dropDownRef.current[index]?.value == "Finish" && (
                    <div className="mt-6 gap-4">
                      <DropDownListComponent
                        buttonType={BUTTON_TYPES.DROPDOWN_GRADIENT_LIST}
                        dataSource={dateTypeDatasource}
                        fields={{ text: "name", value: "value" }}
                        onChange={(e) => {
                          setFinishDateTypeFormat(e.value);
                        }}
                        popupWidth={`${getSizeForColumn()}px`}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }
    if (currentTab == "Validate Data") {
      return (
        <div className="flex flex-col h-full overflow-hidden p-6 w-full justify-between">
          <div className="flex justify-between">
            <div className="font-bold text-xl mb-3 h-6">{t("Validate Data")}</div>
          </div>
          {showValidateData()}
          {isXml && (
            <div className=" flex items-center gap-4 font-semibold text-sm mt-4">
              Select the calendar
              <DropDownButtonComponent
                cssClass="bg-primary_blue px-4 rounded-sg"
                items={calendarDropdownDatasource}
                select={handleCalendarSelection}
                content={selectedCalendar}
              />
              <div className="ms-8">
                {" "}
                Select week timings
                <DropDownButtonComponent
                  cssClass="bg-primary_blue px-4 rounded-sg ms-4"
                  items={timingsDropdownDatasource}
                  content={workTimingsForDropDown}
                  select={handleTimingsSelection}
                />
              </div>
            </div>
          )}
        </div>
      );
    }
  };
  const importFooterContent = () => (
    <div className="flex gap-4">
      <ButtonComponent buttonType={BUTTON_TYPES.GRADIENT_BUTTON} onClick={handleNextClick} disabled={!enableNextButton}>
        {currentTab == "Vaildate Data" ? t("Confirm") : t("Next")}
      </ButtonComponent>

      {currentTab == "Upload File" ? (
        <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={() => setShowImportModal(false)}>
          {t("Cancel")}
        </ButtonComponent>
      ) : (
        <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={HandleGoBack}>
          {t("Go back")}
        </ButtonComponent>
      )}
    </div>
  );

  const importHeaderContent = () => (
    <div className="w-full">
      <div className="flex justify-between w-full items-center ">
        <div>{t("Import Data")}</div>
      </div>
      <div className="flex items-center justify-center gap-6 mt-4">
        {getHeader("Upload File", 1)}
        {getHeaderLine()}
        {getHeader("Select Header", 2)}
        {getHeaderLine()}
        {getHeader("Match Columns", 3)}
        {getHeaderLine()}
        {getHeader("Validate Data", 4)}
      </div>
    </div>
  );

  const buildCalendarDropdownDatasource = (calendar) => {
    const temp = [];
    if (xmlSoftware == "P6") {
      calendar.forEach((data, index) => {
        temp.push({ text: data.Name, id: index });
      });
    } else if (xmlSoftware == "MSP") {
      calendar.forEach((data, index) => {
        if (data.WeekDays) {
          temp.push({ text: data.Name, id: index });
        }
      });
    }
    setCalendarArray(calendar);
    setCalendarDropdownDatasource(temp);
  };

  const handleConvert = () => {
    try {
      if (file) {
        const reader = new FileReader();
        let json = {};
        reader.onload = (e) => {
          const data = e.target.result;
          const fileExtention = file.name.split(".").pop();
          if (fileExtention === "xml") {
            if (xmlSoftware == "P6") {
              json = convertP6XmlToJson(data, params.scheduleId);
            } else if (xmlSoftware == "MSP") {
              json = convertMspXmlToJson(data, params.scheduleId);
            }
            if (typeof json == "string") {
              dispatch(
                showToastNotification({
                  content: t("Something went wrong or the given file is not as per our Format."),
                  type: TOAST_TYPE_ERROR,
                }),
              );
            } else {
              buildCalendarDropdownDatasource(json.calendar ? json.calendar : []);
              setFinalData(json.data);
              setCurrentTab("Validate Data");
            }
          } else if (["csv", "xls", "xlsx"].includes(fileExtention)) {
            const workbook = XLSX.read(data, { type: "binary", cellDates: true });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];

            json = XLSX.utils.sheet_to_json(worksheet, {
              header: 1,
              blankrows: false,
              raw: false,
            });
            const holidays = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[1]], {
              blankrows: false,
              raw: false,
            });
            setHolidays(holidays);
            setAllJsonData(json);
            setCurrentTab("Select Header");
          } else {
            dispatch(
              showToastNotification({
                content: t("File format not supported"),
                type: TOAST_TYPE_ERROR,
              }),
            );
          }
        };
        reader.readAsBinaryString(file);
      } else {
        dispatch(
          showToastNotification({
            content: t("file not selected"),
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    } catch (error) {
      console.log(error);
      dispatch(
        showToastNotification({
          content: SOMETHING_WENT_WRONG,
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  const handleImportExcel = async () => {
    let response;
    if (source == excelImportSources.ESTIMATE) {
      response = await saveEstimateItemsFromExcelSheet(finalData);
    } else if (source === excelImportSources.SCHEDULE) {
      response = await importScheduleTasks({
        data: finalData,
        calendar: { holidays, workWeek, workTimings },
      });
    } else if (source === excelImportSources.COST_DATABASE) {
      response = await importCostDatabaseItemsFromExcelSheet({
        data: finalData,
        dsrId: sourceId,
      });
    } else if (source == excelImportSources.FILES) {
      const formData = formDataGenerator(customFields);
      response = await importExcelContainers({
        data: finalData,
        currentData: {
          ...currentData,
          ...formData,
        },
      });
    }
    return response;
  };

  const formDataGenerator = (customFields) => {
    const returnObj = {};
    if (customFields) {
      returnObj.formTemplateId = customFields._id;
      returnObj.formFields = requiredFields.filter((x) => !!x.customFieldId);
    }
    return returnObj;
  };

  const handleNextClick = async () => {
    if (currentTab == "Upload File") {
      handleConvert();
      setEnableNextButton(false);
    } else if (currentTab == "Select Header") {
      if (allColumnNames.length !== requiredFields.length) {
        setEnableNextButton(false);
        dispatch(
          showToastNotification({
            content: t("Selected header row has some missing column name."),
            type: TOAST_TYPE_WARNING,
          }),
        );
        return;
      }
      setCurrentTab("Match Columns");
      setEnableNextButton(false);
      autoMatching();
    } else if (currentTab == "Match Columns") {
      validatorFunction();
      setCurrentTab("Validate Data");
    } else if (currentTab == "Validate Data") {
      setEnableNextButton(false);
      const res = await handleImportExcel();
      if (source == excelImportSources.FILES) {
        const toastData = {
          content: SOMETHING_WENT_WRONG,
          type: TOAST_TYPE_ERROR,
        };
        if (res.data.status) {
          const arr = res.data.data;

          if (arr.length == finalData.length) {
            const incorrectData = finalData.reduce((array, container, index) => {
              if (!arr[index].status) {
                array.push({
                  ...container,
                  type: arr[index].message || "",
                });
              }
              return array;
            }, []);

            if (incorrectData.length) {
              setFinalData(incorrectData);
              setExcelImported(true);
              toastData.type = TOAST_TYPE_WARNING;
              toastData.content = "Some of the containers have issues.";
            } else {
              setShowImportModal(false);
              toastData.type = TOAST_TYPE_SUCCESS;
              toastData.content = "Imported Successfully !!.";
              refreshDataGrid(true);
            }
          } else {
            setShowImportModal(false);
          }
        } else {
          setShowImportModal(false);
        }
        dispatch(showToastNotification(toastData));
      } else {
        if (res.data.status) {
          setShowImportModal(false);
          dispatch(
            showToastNotification({
              content: t("Imported Successfully !!"),
              type: TOAST_TYPE_SUCCESS,
            }),
          );
          if (source == excelImportSources.ESTIMATE || source == excelImportSources.COST_DATABASE) {
            refreshDataGrid(true);
          } else {
            window.location.reload();
          }
        } else {
          dispatch(
            showToastNotification({
              content: res.data.message,
              type: TOAST_TYPE_ERROR,
            }),
          );
        }
        setEnableNextButton(true);
      }
    }
  };

  const HandleGoBack = () => {
    if (currentTab == "Select Header") {
      setCurrentTab("Upload File");
      if (file) setEnableNextButton(true);
    } else if (currentTab == "Match Columns") {
      setColumnMapper({});
      setCurrentTab("Select Header");
      setEnableNextButton(false);
    } else if (currentTab == "Validate Data") {
      if (isXml) {
        setCurrentTab("Upload File");
      } else {
        setCurrentTab("Match Columns");
      }
    }
  };

  return (
    <ModalStateDialogComponent
      height="80%"
      allowModalPadding={false}
      footerContent={importFooterContent()}
      width="80%"
      onCancel={() => setShowImportModal(false)}
      headerTitle={importHeaderContent()}
      isVisible={showImportModal}
      modelContent={importModalContent()}
    />
  );
}
export default ExcelImport;
